import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import AverageAttendanceActions, { AverageAttendanceRedux, AverageAttendanceTypes } from '../Redux/AverageAttendanceRedux'
import { notificationFail } from '../Redux/NotificationActions'

const averageAttendanceCrudObservable = createCRUDObservable({
  mainRedux: AverageAttendanceRedux,
  reduxPath: 'averageAttendance',
})

const averageAttendanceExcelEpic = (action$, store, { Api }) =>
  action$.ofType(AverageAttendanceTypes.AverageAttendanceExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.averageAttendance.getAverageAttendanceExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            AverageAttendanceActions.AverageAttendanceExcelSuccess(),
          ]
        })
    ))

export const averageAttendanceObservers = Object.assign({}, averageAttendanceCrudObservable.observers, {})

export const averageAttendanceEpic = combineEpics(
  averageAttendanceCrudObservable.epic,
  averageAttendanceExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/AverageAttendanceObservable.js